/**
 * dir-w | backOffice
 * Model for authenticated user
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { User } from "./user.model";

export class Auth {
  constructor(
    public user: User | null = null,
    public _token: string | null = null,
    public _tokenExpiredDate: Date | null = null
  ) {}
}
